// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__3RdrB","has-label":"Checkbox_has-label__e7Cho","white":"Checkbox_white__0mAAP"};